import { getStyle } from './DatanauswertungGenerischStyles';
import * as React from 'react';
import { WpdfText } from '../pdf/WpdfText.';
import { WpdfView } from '../pdf/WpdfView';

export function renderRows(config: any, isPDF: boolean, fontFactor?: number, noInfo?: boolean) {
    const {
        baseWidth, custom_layout, custom_row_classes, diagrams, noRenderRowsCheck, row_classes, row_web_forced, rows, rows_width, values
    } = config;
    const data: any = {};
    const groups: any = {};
    const row_groups: any[] = (values || {}).row_groups || [];
    let indexGroup: number = -1;
    (rows || []).forEach((item: any[], idx: number) => {
        const web_forced: boolean = !!(row_web_forced || [])[idx];
        if ((isPDF && rowHasValues(item) && !web_forced) || (!isPDF && (rowHasValues(item) || web_forced))) {
            const row_group: any = row_groups[idx] || {};
            data[idx] = item;
            if (typeof row_group.name !== 'string' || row_group.pos === 0) {
                groups[++indexGroup] = {};
            }
            groups[indexGroup][idx] = item;
        }
    });
    // console.log('diagrams: ', diagrams);
    if (!noRenderRowsCheck && !noInfo && isPDF && Object.keys(data).length > 10 && diagrams && diagrams.length > 0) {
        const tempelement = document.createElement('div');
        tempelement.innerHTML = '&rarr;';
        // alert(`Die Darstellung auf einer PDF-Seite ist nur für bis zu 10 aufeinander folgende Datenjahre möglich.\n\nWenn sie mehr als 10 Datenjahre drucken möchten, werden die Datentabelle und die Grafiken auf zwei verschiedenen Seiten gedruckt.\n\nSofern Sie die Ausgabe auf eine Seite beschränken möchten, wählen Sie bitte links oben (${tempelement.innerHTML} "Jahr") einen entsprechenden Zehnjahreszeitraum.`);
    }
    return (
        <WpdfView
            style={getStyle('rows_main', isPDF, fontFactor)}
            pdf={isPDF}
        >
            {Object.keys(groups).map((group: string) =>
                <WpdfView
                    key={`row-group-${group}`}
                    style={{ flexDirection: 'column' }}
                    pdf={isPDF}
                    // nowrap={Object.keys(groups[group]).length < 21} // 37
                    nowrap={Object.keys(groups[group]).length < 14} // 37
                >
                    {Object.keys(groups[group]).map((i: string) => {
                        const row: any = groups[group][i];
                        let subCols: number = 1;
                        let idxCols: number = -1;
                        return (
                            <WpdfView
                                key={`row-${i}`}
                                style={getStyle('row', isPDF, fontFactor)}
                                pdf={isPDF}
                                nowrap
                            >
                                {row.map((value: any, idx: number) => {
                                    // const width = Array.isArray(rows_width) && rows_width[idx] ? rows_width[idx] : baseWidth;
                                    const className = custom_row_classes && custom_row_classes[i] && custom_row_classes[i][idx]
                                        ? custom_row_classes[i][idx]
                                        : row_classes && row_classes[idx] ? row_classes[idx] : 'row_field';
                                    const valText =
                                        typeof value === 'function' // Es geht um einen render wie renderZuschlagEingabe.
                                            ? value(isPDF)
                                            : (isPDF && typeof value === 'object'
                                                ? (value !== null ? (value.props || {})['data-text'] || null : null) // DOM-Elemente in PDF nicht möglich
                                                : value);
                                    const style: any = getStyle(className, isPDF, idx === 0 ? 1 : fontFactor, custom_layout);
                                    const cols: number = style.cols || null;
                                    subCols = subCols > 1 ? --subCols : cols || 1;
                                    if (!cols || (cols && subCols === cols)) {
                                        ++idxCols;
                                    }
                                    const width = Array.isArray(rows_width) && rows_width[idxCols]
                                        ? (cols > 1 ? rows_width[idxCols] / cols : rows_width[idxCols])
                                        : baseWidth;
                                    delete style.cols;
                                    const cellWidth: any = className.endsWith('_none') && style.flex === 0
                                        ? {} : { width: `${width}%` };
                                    // console.log(className, valText, fontFactor, getStyle(className, isPDF, idx === 0 ? 1 : fontFactor));
                                    const cssCell: React.CSSProperties = {
                                        ...style, ...cellWidth, height: 'auto', minHeight: style.height, display: 'flex',
                                        flexDirection: 'column',
                                        ...(idx === 0 ? { borderLeft: 0 } : {}),
                                        ...((typeof value === 'object' && value !== null && (value.props || {})['data-text'])
                                            ? { overflow: 'visible' } : {}
                                        )
                                    };
                                    return (
                                        <WpdfView key={`value-${idx}`} style={cssCell} pdf={isPDF}>
                                            {(valText && (valText + '').charAt(0) === '#')
                                                ? renderCustomFormat(valText, isPDF)
                                                : (idx === 1
                                                    ? makeLineBreaks(valText, isPDF)
                                                    : <WpdfText pdf={isPDF}>{valText}</WpdfText>
                                                )
                                            }
                                            {/* <WpdfText pdf={isPDF}>
                                                {idx === 1 ? makeLineBreaks(valText, isPDF) : valText}
                                            </WpdfText> */}
                                        </WpdfView>
                                    );
                                })}
                            </WpdfView>
                        );
                    })}
                </WpdfView>
            )}
        </WpdfView>
    );
}

function makeLineBreaks(input: string, isPdf: boolean) {
    if (!input || !input.split) {
        return input;
    }
    const split_arr = input.split('\n');
    if (split_arr.length > 1) {
        return (
            <WpdfView
                pdf={isPdf}
                style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
                    // lineHeight: isPdf ? 1.9 : 1.4 // Verursacht Memory-Leak !
                }}
            >
                {split_arr.map((item: string) =>
                    <WpdfView pdf={isPdf} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', height: 18 }}>
                        <WpdfText pdf={isPdf} style={{ flex: 1 }}>{item}</WpdfText>
                        {/*<WpdfText
                        pdf={isPdf}
                        style={{ flex: 1, maxWidth: 2, minWidth: 2, width: 2, arginLeft: 0, textAlign: 'center', borderLeft: '0pt solid white' }}
                    >
                        {' '}
                    </WpdfText>*/}
                    </WpdfView>
                )}
            </WpdfView>
        );
    }
    return <WpdfText pdf={isPdf}>{input}</WpdfText>;
}

function renderCustomFormat(input: string, isPdf: boolean): JSX.Element | string {
    const split = input.split('#');
    // console.log('renderCustomFormat', split, input);
    const type = split[1];
    if (type === 'quellen') {
        const jsx_arr: JSX.Element[] = [];
        for (let i = 2; i < split.length; i++) {
            const str_item = split[i];
            if (!str_item) {
                continue;
            }
            const split_item = str_item.split('__');
            // console.log('SplitItem: ', str_item, split_item);
            const jsx_item = <WpdfView pdf={isPdf} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', height: 18 }}>
                <WpdfText pdf={isPdf} style={{ flex: 1 }}>{split_item[0] + ' ' + split_item[1]}</WpdfText>
                <WpdfText
                    pdf={isPdf}
                    style={{ flex: 1, maxWidth: 20, marginLeft: 10, textAlign: 'center', borderLeft: '1pt solid white' }}
                    tooltip={split_item[3].replace(/;;/g, '\n')}
                >
                    {split_item[2]}
                </WpdfText>
            </WpdfView>;
            jsx_arr.push(jsx_item);
        }
        return <WpdfView pdf={isPdf} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
            {jsx_arr}
        </WpdfView>;
    } else if (type === 'quelle') {
        return <WpdfView pdf={isPdf} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            <WpdfText pdf={isPdf} style={{ flex: 1 }}>{split[2] + ' ' + split[3]}</WpdfText>
            <WpdfText
                pdf={isPdf}
                style={{ flex: 1, maxWidth: 20, marginLeft: 10, textAlign: 'center', borderLeft: '1pt solid white' }}
                tooltip={split[5].replace(/;;/g, '\n')}
            >
                {split[4]}
            </WpdfText>
        </WpdfView>;
    } else if (type === 'flaechen_aenderung') {
        return <WpdfView pdf={isPdf} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            <WpdfText pdf={isPdf} style={{ flex: 1 }}>{split[3]}%</WpdfText>
            <WpdfText pdf={isPdf} style={{ flex: 1, maxWidth: 100, marginLeft: 10, textAlign: 'right', borderLeft: '1pt solid #fff' }}>
                {split[2]}
            </WpdfText>
        </WpdfView>;
    }
    return input;
}

export function rowHasValues(row: any): boolean {
    // console.log('RHV?:', row);
    let hasValue = false;
    row.forEach((value: any, idx: number) => {
        const v: any = typeof value === 'object' && value !== null && typeof (value.props || {})['data-text'] !== 'undefined'
            ? value.props['data-text'] : value;
        const v2 = v ? (v + '').split(',').join('').split('0').join('').trim() : undefined;
        // console.log('v2', v2);
        if (idx > 0 && v && (v + '').trim() !== '' && v2 !== '') {
            hasValue = true;
        }
    });
    return hasValue;
}
